<template>
    <div class="page_box">
      <div class="left_box" :class="LeftNavStyle?LeftNavStyle:''">
        <div class="border_box">
          <div class="top_box">
            <span class="sname">
              <img :src="AppPageLogo" alt="" style="height:30px;" />
              {{AppPageTitle}}
            </span>
            <i class="iconfont openico" :class="LeftNavShow?'hide':''" @click.prevent="NavShowHide()">&#xe6af;</i>
          </div>
          <!-- 新建对话 -->
          <div class="addnewmsg">
            <div class="addbtn" @click.prevent="AddNewMsgBtn" :style="{'width': (LeftNavShow?'calc(100% - 40px)':'100%'),'border-radius': (LeftNavShow?'10px':'0px')}">
              <i class="iconfont">&#xe6be;</i>{{(LeftNavShow?'新建对话':'')}}
            </div>
          </div>
          <!-- 用户历史记录 -->
          <div class="list_box">
            <Scrollbar wrap-class="scrollbar-wrapper" class="scrollbox" v-show="LeftNavShow">
              <div class="nomsg" v-if="UserMsgData.length==0">暂无历史记录</div>
              <div class="grouptit" v-if="UserMsgDataTop.length>0" @click="UserMsgShow('Top')">置顶<i class="el-icon-arrow-up" v-if="UserMsgDataTopShow"></i><i class="el-icon-arrow-down" v-if="!UserMsgDataTopShow"></i></div>
              <div class="msg_box" v-if="UserMsgDataTop.length>0&&UserMsgDataTopShow">
                <div class="lbox" v-for="(item,index) in UserMsgDataTop" :key="index" :class="(UserMsgNow.ChatId==item.ChatId?'on':'')">
                  <div class="title nowrap" @click.prevent="GetChatRecordList(item.ChatId,item)">{{item.ChatTitle}}</div>
                  <Dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        <i class="iconfont">&#xe6a3;</i>
                    </span>
                    <DropdownMenu slot="dropdown">
                      <DropdownItem :command="{type:'edit',data:item}"><i class="el-icon-edit-outline"></i>编辑名称</DropdownItem>
                      <DropdownItem :command="{type:'top',data:item}"><i :class="item.IsTop?'el-icon-download':'el-icon-upload2'"></i>{{item.IsTop?'取消置顶':'置顶'}}</DropdownItem>
                      <DropdownItem :command="{type:'del',data:item}"><i class="el-icon-circle-close"></i>删除</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
              
              <div class="grouptit" v-if="UserMsgData1Day.length>0" @click="UserMsgShow('1Day')">今天<i class="el-icon-arrow-up" v-if="UserMsgData1DayShow"></i><i class="el-icon-arrow-down" v-if="!UserMsgData1DayShow"></i></div>
              <div class="msg_box" v-if="UserMsgData1Day.length>0&&UserMsgData1DayShow">
                <div class="lbox" v-for="(item,index) in UserMsgData1Day" :key="index" :class="(UserMsgNow.ChatId==item.ChatId?'on':'')">
                  <div class="title nowrap" @click.prevent="GetChatRecordList(item.ChatId,item)">{{item.ChatTitle}}</div>
                  <Dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                      <i class="iconfont">&#xe6a3;</i>
                    </span>
                    <DropdownMenu slot="dropdown">
                      <DropdownItem :command="{type:'edit',data:item}"><i class="el-icon-edit-outline"></i>编辑名称</DropdownItem>
                      <DropdownItem :command="{type:'top',data:item}"><i :class="item.IsTop?'el-icon-download':'el-icon-upload2'"></i>{{item.IsTop?'取消置顶':'置顶'}}</DropdownItem>
                      <DropdownItem :command="{type:'del',data:item}"><i class="el-icon-circle-close"></i>删除</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
  
              <div class="grouptit" v-if="UserMsgData7Day.length>0" @click="UserMsgShow('7Day')">7天内<i class="el-icon-arrow-up" v-if="UserMsgData7DayShow"></i><i class="el-icon-arrow-down" v-if="!UserMsgData7DayShow"></i></div>
              <div class="msg_box" v-if="UserMsgData7Day.length>0&&UserMsgData7DayShow">
                <div class="lbox" v-for="(item,index) in UserMsgData7Day" :key="index" :class="(UserMsgNow.ChatId==item.ChatId?'on':'')">
                  <div class="title nowrap" @click.prevent="GetChatRecordList(item.ChatId,item)">{{item.ChatTitle}}</div>
                  <Dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        <i class="iconfont">&#xe6a3;</i>
                    </span>
                    <DropdownMenu slot="dropdown">
                      <DropdownItem :command="{type:'edit',data:item}"><i class="el-icon-edit-outline"></i>编辑名称</DropdownItem>
                      <DropdownItem :command="{type:'top',data:item}"><i :class="item.IsTop?'el-icon-download':'el-icon-upload2'"></i>{{item.IsTop?'取消置顶':'置顶'}}</DropdownItem>
                      <DropdownItem :command="{type:'del',data:item}"><i class="el-icon-circle-close"></i>删除</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
  
              <div class="grouptit" v-if="UserMsgData30Day.length>0" @click="UserMsgShow('30Day')">30天内<i class="el-icon-arrow-up" v-if="UserMsgData30DayShow"></i><i class="el-icon-arrow-down" v-if="!UserMsgData30DayShow"></i></div>
              <div class="msg_box" v-if="UserMsgData30Day.length>0&&UserMsgData30DayShow">
                <div class="lbox" v-for="(item,index) in UserMsgData30Day" :key="index" :class="(UserMsgNow.ChatId==item.ChatId?'on':'')">
                  <div class="title nowrap" @click.prevent="GetChatRecordList(item.ChatId,item)">{{item.ChatTitle}}</div>
                  <Dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        <i class="iconfont">&#xe6a3;</i>
                    </span>
                    <DropdownMenu slot="dropdown">
                      <DropdownItem :command="{type:'edit',data:item}"><i class="el-icon-edit-outline"></i>编辑名称</DropdownItem>
                      <DropdownItem :command="{type:'top',data:item}"><i :class="item.IsTop?'el-icon-download':'el-icon-upload2'"></i>{{item.IsTop?'取消置顶':'置顶'}}</DropdownItem>
                      <DropdownItem :command="{type:'del',data:item}"><i class="el-icon-circle-close"></i>删除</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
  
              <div class="grouptit" v-if="UserMsgDataOrther.length>0" @click="UserMsgShow('Orther')">更早<i class="el-icon-arrow-up" v-if="UserMsgDataOrtherShow"></i><i class="el-icon-arrow-down" v-if="!UserMsgDataOrtherShow"></i></div>
              <div class="msg_box" v-if="UserMsgDataOrther.length>0&&UserMsgDataOrtherShow">
                <div class="lbox" v-for="(item,index) in UserMsgDataOrther" :key="index" :class="(UserMsgNow.ChatId==item.ChatId?'on':'')">
                  <div class="title nowrap" @click.prevent="GetChatRecordList(item.ChatId,item)">{{item.ChatTitle}}</div>
                  <Dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        <i class="iconfont">&#xe6a3;</i>
                    </span>
                    <DropdownMenu slot="dropdown">
                      <DropdownItem :command="{type:'edit',data:item}"><i class="el-icon-edit-outline"></i>编辑名称</DropdownItem>
                      <DropdownItem :command="{type:'top',data:item}"><i :class="item.IsTop?'el-icon-download':'el-icon-upload2'"></i>{{item.IsTop?'取消置顶':'置顶'}}</DropdownItem>
                      <DropdownItem :command="{type:'del',data:item}"><i class="el-icon-circle-close"></i>删除</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
              
            </Scrollbar>
          </div>
          <!-- 左侧底部 -->
          <div class="bottom_box">
            <span class="user">{{LeftNavShow?'用户：':''}}<span class="name">{{UserData.NickName}}<span class="vip" v-if="VipData.VipType==1||(VipData.VipType==2&&VipData.VipNumber>0)"><i class="iconfont">&#xe6ae;</i></span></span><span v-if="!IsLogin&&LeftNavShow" class="tlogin" @click="$router.push('/login')">前往登录</span></span>
          </div>
        </div>
      </div>
      <!-- 右侧对话区 -->
      <div class="dialog_box" :class="(ContentStyle?ContentStyle:'')">
        <div class="content_on">
          <Dropdown trigger="click" @command="handleCommand" style="width:calc(100% - 375px);overflow:hidden;float:left;">
            <span class="el-dropdown-link">
              <span class="nowrap" style="width:calc(100% - 80px);display:inline-block;">{{UserMsgNow.ChatTitle?UserMsgNow.ChatTitle:'新对话'}}</span>
              <i class="iconfont" v-if="UserMsgNow.ChatTitle" style="position: absolute;top:0px;right:0px;text-indent:0px;">&#xe6b2;</i>
            </span>
            <DropdownMenu slot="dropdown" v-if="UserMsgNow.ChatTitle">
              <DropdownItem :command="{type:'edit',data:UserMsgNow}"><i class="el-icon-edit-outline"></i>编辑名称</DropdownItem>
              <DropdownItem :command="{type:'top',data:UserMsgNow}"><i :class="UserMsgNow.IsTop?'el-icon-download':'el-icon-upload2'"></i>{{UserMsgNow.IsTop?'取消置顶':'置顶'}}</DropdownItem>
              <DropdownItem :command="{type:'del',data:UserMsgNow}"><i class="el-icon-circle-close"></i>删除</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <div style="display:inline-block;float:left;">
            <div class="export_all_content_btn el-icon-upload2" v-if="UserMsgNow.ChatTitle" @click="AllConetntExport()"> 导出对话</div>
            <div class="export_all_content_btn iconfont clipboard_share" :data-clipboard-text="ClipboardUrl" v-if="UserMsgNow.ChatTitle" @click="AllConetntShare()">&#x1020b; 分享对话</div>
          </div>
          
        </div>
        <!-- 对话板 -->
        <div class="dialog_content" id="dialogcontent">
          <div class="default-box" v-if="DefaultBoxShow">
            <div class="dbox">
              <div class="lntxt">
                <img class="logo" :src="AppPageLogo" alt=""/>
                <div class="name">{{AppPageTitle}}</div>
                <div class="clear"></div>
              </div>
              <div class="greetings">{{AppPageGreetings}}</div>
            </div>
          </div>
          <div class="content_div" id="All_Conetnt_Export">
            <div class="content_box" :class="item.Type" v-for="(item,index) in AIQuestionAnswerData" :key="index" v-show="!item.Hide">
              <div class="text">
                <div :class="(item.TinkTxt=='思考中...'?'thinking':'thinked')" v-if="item.Type=='left'&&item.TinkTxt" @click.prevent="ContentShowOrHide(item.Id)">{{item.TinkTxt}}<i class="iconfont" :class="item.ConShow?'up':''" v-show="item.TinkTxt!='思考中...'">&#xe6aa;</i></div>
                <div class="content" :class="item.TinkTxt?'think':''" v-show="((item.Type=='left'&&item.TinkTxt)?(item.ConShow):true)">
                  <vue-markdown :id="item.Id" :source="item.Content" table-class="markdown-table-class" :class="'jzy-vue-markdown-class-'+(item.Type=='left'?'left':'')"></vue-markdown>
                </div>
              </div>
              <div class="clear"></div>
            </div>
            <div id="markdown-wait-animate"><div class="ico"><i class="iconfont">&#xe6ab;</i></div></div>
          </div>
        </div>
        <!-- 发送信息 -->
        <div class="dialog_bot">
          <div class="input_div">
            <div class="linear"></div>
            <div class="item_box">
              <div class="itemcon">
                <div style="width:550px;">
                  <div class="item" @click.prevent="QListOpen(item)" v-for="(item,index1) in QuestionCategoryData" :key="index1"><i class="iconfont">&#xe856;</i>{{item.CategoryName}}</div>
                </div>
              </div>
            </div>
            <div class="dialog_input">
              <div class="input_box">
                <textarea v-model="UserMessage" class="textarea" id="UserMessageInput" :placeholder="IsLogin?'Shift + Enter 换行 , Enter 发送':'请先登录'"></textarea>
                <div class="botton">
                  <div class="lbtns">
                    <div class="btn sd" :class="IsDeepThink?'on':''" @click.prevent="SendSet('IsDeepThink')"><i class="iconfont">&#xe6b9;</i>深度思考</div>
                    <div class="btn lw" :class="IsWebSearch?'on':''" @click.prevent="SendSet('IsWebSearch')"><i class="iconfont">&#xe6bd;</i>联网搜索</div>
                  </div>
                  <div class="rbtns">
                    <div class="btn num" v-if="VipData.VipType==2&&VipData.VipNumber>0">剩余：{{VipData.VipNumber}} 次</div>
                    <div class="btn send" @click.prevent="SendMsgDialogBox()"><i class="iconfont">&#xe6e3;</i></div>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom_div">
          <span>所有内容均由AI生成仅供参考 请仔细甄别</span>
        </div>
      </div>
      <!-- 编辑名称 -->
      <Dialog title="编辑名称" :visible.sync="dialogEditVisible" :close="dialogEditClose">
        <Form>
          <FormItem label="名称" label-width="120px">
            <Input v-model="FormEdit.ChatTitle" clearable maxlength="50"></Input>
          </FormItem>
        </Form>
        <div slot="footer" class="dialog-footer">
          <Button @click="dialogEditClose">取 消</Button>
          <Button type="primary" @click="UserMsgEditSubmit">确 定</Button>
        </div>
      </Dialog>
      <!-- 常用问题 -->
      <Drawer :visible.sync="QListShow" title="你可以这样问" size="320px" direction="ltr" :before-close="QListClose" class="qlist_box">
        <Scrollbar wrap-class="scrollbar-wrapper" class="scrollbox">
          <div class="qtitle">{{QListType.CategoryName}}</div>
          <div class="qtxt" @click.prevent="QListBtn(item.QuestionTitle)" v-for="(item,index) in QuestionInfoData" :key="index">{{item.QuestionTitle}}<i class="el-icon-arrow-right"></i></div>
          <div style="height:30px;"></div>
        </Scrollbar>
      </Drawer>
      <!--放大表格-->
      <div class="amplifytablebox" v-if="AmplifyTableShow">
        <div class="conbox">
          <Scrollbar wrap-class="scrollbar-wrapper" class="tablescroll">
            <div class="tablebox" v-html="AmplifyTableHtml" id="table_export_pdf_box"></div>
          </Scrollbar>
          <div class="btnbox">
            <div class="exportbtn" @click="TableExport()">导出</div>
            <div class="closebtn" @click="AmplifyTableShow=false">关闭</div>
          </div>
        </div>
      </div>
      <!-- 加载效果 -->
      <div id="result_download_loading" style="display:none;width:100%;height:100%;position:fixed;left:0px;top:0px;z-index:888;background-color:rgba(0,0,0,0.2);">
        <div style="width:200px;height:80px;position:absolute;top:calc(50% - 40px);left:calc(50% - 100px);text-align:center;">
          <i class="el-icon-loading" style="font-size:40px;color:#fff;"></i>
          <span style="display:block;font-size:20px;color:#555;margin-top:10px;">PDF生成中…</span>
        </div>
      </div>
  
      <!--手动复制-->
      <div class="fz_box_div" v-if="fzboxshow">
        <div class="fzbox">
          <div class="tit">分享地址</div>
          <a class="link" target="_blank" :href="ClipboardUrl">{{ClipboardUrl}}</a>
          <div class="mark">手动复制或点击地址通过浏览器复制</div>
          <div class="close" @click.prevent="fzboxshow=false">关闭</div>
        </div>
      </div>
  
    </div>
  </template>
  <script>
  import API from "@/api/config";
  import Config from '@/config/config';
  import { Message,Scrollbar,Dropdown,DropdownMenu,DropdownItem,Dialog,Form,FormItem,Input,Button,Popconfirm, MessageBox,Drawer } from 'element-ui';
  import {getStore,setStore,parseTime,deepClone} from "@/utils/utils";
  import { fetchEventSource } from '@microsoft/fetch-event-source';
  import VueMarkdown from 'vue-markdown';
  import {downloadPDF} from "@/utils/pdf-chat.js";  //转换PDF
  import Clipboard from "clipboard";
  export default {
    components: {
      VueMarkdown,Scrollbar,Dropdown,DropdownMenu,DropdownItem,
      Dialog,Form,FormItem,Input,Button,Popconfirm,Drawer
    },
    data(){
      return{
        AppPageLogo:'',
        AppPageTitle:'',
        AppPageGreetings:'',
        DefaultBoxShow:false,
        SendChatId:null,
        
        UserMessage:'',
        AIQuestionAnswerData:[],
  
        IsSendOk:true,
  
        LeftNavShow:true,
        LeftNavStyle:'',
        ContentStyle:'',
  
        UserData:{},
        UserMsgData:[],
        UserMsgDataTop:[],
        UserMsgData1Day:[],
        UserMsgData7Day:[],
        UserMsgData30Day:[],
        UserMsgDataOrther:[],
  
        UserMsgDataTopShow:true,
        UserMsgData1DayShow:true,
        UserMsgData7DayShow:true,
        UserMsgData30DayShow:true,
        UserMsgDataOrtherShow:true,
  
        dialogEditVisible:false,
        FormEdit:{
          ChatId:null,
          ChatTitle:''
        },
        UserMsgNow:{},
        IsDeepThink:true,
        IsWebSearch:false,
  
        QListShow:false,
        QListType:{},
  
        userctrl:null,
  
        VipData:{
          VipType:null,// 1、不限制次数；2、限制次数
          VipNumber:0
        },
  
        AmplifyTableShow:false,
        AmplifyTableHtml:'',
  
        IsLogin:false,
  
        QuestionCategoryData:[],
        QuestionInfoData:[],
        ClipboardUrl:'',
  
        isDragging: false,
        startX: 0,
        startY: 0,
        scrollStart: 0,
  
        fzboxshow:false
      }
    },
    beforeDestroy() {
      if(this.userctrl){
        this.userctrl.abort();
      }
    },
    mounted(){
      this.getLoginStatus();
      this.GetGreetings();//问候语
      let that = this;
      const UserMessageInput = document.getElementById('UserMessageInput');
      UserMessageInput.addEventListener('keydown', function(e) {
        // Shift+Enter 换行
        if (e.key === 'Enter' && e.shiftKey) {
          // 允许默认的换行行为
          return;
        }
        // Enter 发送消息（没有按下Shift）
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault(); // 阻止默认的换行行为
          that.SendMsgDialogBox();
        }
      });
    },
    methods:{
      AllConetntShare() {
        const clipboard = new Clipboard(".clipboard_share");
        clipboard.on("success", (e) => {
          Message({ type: 'success', message: '链接已复制到剪贴板！'});
          clipboard.destroy();// 释放内存
        });
        clipboard.on("error", (e) => {
          Message({ type: 'info', message: '该浏览器不支持自动复制，请手动复制！'});
          clipboard.destroy();// 释放内存
          //打开手动复制
          this.fzboxshow=true;
        });
      },
      GetQuestionCategoryList(){
        API.Chat.GetQuestionCategoryList({OrgId:JSON.parse(getStore('LoginData')).OrgId}).then(res1=>{
          if(res1.Code==0&&res1.Data){
            this.QuestionCategoryData = res1.Data;
          }
        })
      },
      getLoginStatus(){
        API.Web.LoginStatus().then(resuser => {
          if(resuser.Code==0&&resuser.Data){
            setStore("LoginData", resuser.Data);
            this.IsLogin = true;
            this.UserData = resuser.Data;
            API.Personal.GetUserStudent().then(res => {
              if (res.Code == 0 && res.Data) {
                this.$nextTick(()=>{
                  let st = setTimeout(()=>{
                    this.GetChatList();
                    this.IsVip();
                    this.GetQuestionCategoryList();
                    clearTimeout(st);
                  },200);
                });
              }
            });
          }
        });
      },
      UserMsgShow(type){
        if(type=='Top'){
          if(this.UserMsgDataTopShow){
            this.UserMsgDataTopShow=false;
          }
          else{
            this.UserMsgDataTopShow=true;
          }
        }
        else if(type=='1Day'){
          if(this.UserMsgData1DayShow){
            this.UserMsgData1DayShow=false;
          }
          else{
            this.UserMsgData1DayShow=true;
          }
        }
        else if(type=='7Day'){
          if(this.UserMsgData7DayShow){
            this.UserMsgData7DayShow=false;
          }
          else{
            this.UserMsgData7DayShow=true;
          }
        }
        else if(type=='30Day'){
          if(this.UserMsgData30DayShow){
            this.UserMsgData30DayShow=false;
          }
          else{
            this.UserMsgData30DayShow=true;
          }
        }
        else if(type=='Orther'){
          if(this.UserMsgDataOrtherShow){
            this.UserMsgDataOrtherShow=false;
          }
          else{
            this.UserMsgDataOrtherShow=true;
          }
        }
      },
      QListOpen(t){
        if(this.IsLogin){
          this.QListShow=true;
          this.QListType=t;
          API.Chat.GetQuestionList({categoryId:t.Id}).then(res=>{
            if(res.Code==0&&res.Data){
              this.QuestionInfoData = res.Data;
            }
          })
        }
        else{
          this.$router.push("/login");
        }
      },
      IsVip(){
        API.Web.LoginStatus().then(res => {
          if(res.Code==0&&res.Data){
            // 初始化会员信息
            this.VipData={
              VipType:null,// 1、不限制次数；2、限制次数
              VipNumber:0
            };
            // 循环会员权限
            for(let i = 0;i<res.Data.RightsList.length;i++){
              // 筛选AI卡
              if(res.Data.RightsList[i].RightsCode=='AIChat'){
                // 验证是否过期
                let date = res.Data.RightsList[i].ExpireAt?new Date(res.Data.RightsList[i].ExpireAt):'';
                if(date){
                  // 未过期
                  if(new Date()<date){
                    // 判断是次卡还是不限次数
                    if(res.Data.RightsList[i].Count==null||res.Data.RightsList[i].Count=='null'){
                      // 是不限制次数的会员，直接跳出循环
                      this.VipData.VipType=1;
                      return;
                    }
                    else{
                      // 是次卡，累计剩余次数
                      this.VipData.VipType=2;
                      this.VipData.VipNumber+=parseInt(res.Data.RightsList[i].Count);
                    }
                  }
                }
              }
            }
          }
        });
      },
      // 阻止Enter键默认行为
      PreventDefaultEnter(e){
        if (e.key === 'Enter' && e.shiftKey) {
          // 允许默认的换行行为
          return;
        }
        // Enter 发送消息（没有按下Shift）
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault(); // 阻止默认的换行行为
        }
      },
      // 深度思考、联网搜索
      SendSet(type){
        if(type=='IsDeepThink'){
          this.IsDeepThink = (this.IsDeepThink?false:true);
        }
        else{
          this.IsWebSearch = (this.IsWebSearch?false:true);
        }
      },
      handleCommand(command) {
        // 编辑名称
        if(command.type=='edit'){
          this.dialogEditVisible=true;
          this.FormEdit.ChatId=command.data.ChatId;
          this.FormEdit.ChatTitle=command.data.ChatTitle;
        }
        // 置顶
        else if(command.type=='top'){
          this.UserMsgTopSubmit(command.data.ChatId,(command.data.IsTop?false:true));
        }
        // 删除
        else if(command.type=='del'){
          MessageBox.confirm("该对话内容将被删除无法恢复，确定删除吗？", "注意！", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.UserMsgDelSubmit(command.data.ChatId);
          })
          .catch(() => {});
        }
      },
      // 编辑名称
      UserMsgEditSubmit(){
        API.Chat.UpdateChatTitle(this.FormEdit).then(res => {
          if (res.Code === 0) {
            this.dialogEditClose();
            this.GetChatList();
            Message({ type: 'success', message: "编辑成功！"});
          }
          else {
            Message({ type: 'error', message: res.Message});
          }
        });
      },
      // 编辑名称关闭
      dialogEditClose(){
        this.dialogEditVisible=false;
        this.FormEdit.ChatId=null;
        this.FormEdit.ChatTitle='';
      },
      // 置顶提交
      UserMsgTopSubmit(id,bool){
        API.Chat.SetTop({ChatId:id,IsTop:bool}).then(res => {
          if (res.Code === 0) {
            this.GetChatList();
            Message({ type: 'success', message: (bool?"置顶成功！":"取消成功！")});
          }
          else {
            Message({ type: 'error', message: res.Message});
          }
        });
      },
      // 删除提交
      UserMsgDelSubmit(id){
        API.Chat.DelChat({ChatId:id}).then(res => {
          if (res.Code === 0) {
            this.GetChatList();
            Message({ type: 'success', message: "删除成功！"});
            //如果删除当前对话，创建新对话
            if(id==this.UserMsgNow.ChatId){
              this.AddNewMsgBtn();
            }
          }
          else {
            Message({ type: 'error', message: res.Message});
          }
        });
      },
      // 获取历史记录
      GetChatList(id){
        API.Chat.GetChatList({UserId:this.UserData.UserId}).then(res => {
          if (res.Code === 0) {
            this.UserMsgData = res.Data;
            if(id){
              this.UserMsgNow=this.UserMsgData.find(f=>f.ChatId==id);
            }
            this.UserMsgDataTop=[];
            this.UserMsgData1Day=[];
            this.UserMsgData7Day=[];
            this.UserMsgData30Day=[];
            this.UserMsgDataOrther=[];
            let nowDate = new Date();
            this.UserMsgData.forEach(item => {
              if(item.IsTop){
                this.UserMsgDataTop.push(item);
              }
              else{
                let num = this.getDaysBetweenDates(nowDate, new Date(item.CreateTime));
                if(parseTime(nowDate,'{y}-{m}-{d}')==parseTime(new Date(item.CreateTime),'{y}-{m}-{d}')){
                  this.UserMsgData1Day.push(item);
                }
                else{
                  if(num>0&&num<=8){
                    this.UserMsgData7Day.push(item);
                  }
                  else if(num>8&&num<=31){
                    this.UserMsgData30Day.push(item);
                  }else{
                    this.UserMsgDataOrther.push(item);
                  }
                }
              }
            });
          }
          // else {
          //   Message({ type: 'error', message: res.Message});
          // }
        });
      },
      getDaysBetweenDates(date1, date2) {
        // 将日期转换为毫秒
        const diffInMs = Math.abs(date2 - date1);
        // 1天 = 24小时 = 24 * 60分钟 = 24 * 60 * 60秒 = 24 * 60 * 60 * 1000毫秒
        return Math.ceil(diffInMs / (24 * 60 * 60 * 1000));
      },
      // 获取对话记录
      GetChatRecordList(cid,obj){
        this.ClipboardUrl = location.origin+'/#/share?shareid='+cid;//复制用
		    this.SendChatId=cid;
        if(obj){
          this.UserMsgNow=obj;
          this.DefaultBoxShow=false;
        }
        API.Chat.GetChatRecordList({ChatId:cid}).then(res => {
          if (res.Code === 0) {
            this.AIQuestionAnswerData=[];
            if(res.Data.length>0){
              let exportArr = [];
              res.Data.forEach(item => {
                let id = 'ai'+new Date(item.ChatTime).getTime();
                if(item.Role=="user"){
                  this.AIQuestionAnswerData.push({Id:id,Type:'right',Content:item.Content});
                }
                else{
                  this.AIQuestionAnswerData.push({Id:id+'think',Type:'left',Content:item.ThinkContent,TinkTxt:item.ThinkTitle,ConShow:true});
                  this.AIQuestionAnswerData.push({Id:id+'content',Type:'left',Content:item.Content});
                  exportArr.push(id+'content');
                }
              });
              // 刷新滚动条
              this.$nextTick(()=>{
                let doms = document.getElementsByClassName('export_now_content_btn');
                if(doms.length>0){
                  doms.forEach(obj=>{
                    obj.remove();
                  })
                }
                this.setTableStyle(exportArr);// 处理table表格样式
                document.getElementById("dialogcontent").scrollTop = document.getElementById("dialogcontent").scrollHeight;
              });
            }
            else{
              this.GetGreetings();//问候语
            }
          }
          // else {
          //   Message({ type: 'error', message: res.Message});
          // }
        });
      },
      // 默认问候语
      GetGreetings(){
        let obj=getStore("ParamList");
        if(obj){
          obj=JSON.parse(obj);
          let obj1 = obj.find(f=>f.ParamKey=='Web_Logo');
          if(obj1){
            this.AppPageLogo = obj1.ParamValue;
          }
          let obj2 = obj.find(f=>f.ParamKey=='WebSEO_AIChatTitle');
          if(obj2){
            this.AppPageTitle = obj2.ParamValue;
          }
          let obj3 = obj.find(f=>f.ParamKey=='WebSEO_AIChatDescription');
          if(obj3){
            this.AppPageGreetings = obj3.ParamValue;
          }
        }
        this.DefaultBoxShow=true;//显示问候语
      },
      // 客户端打字效果
      DefaultTypeWriter(text, id, speed) {
        let i = 0;
        const interval = setInterval(() => {
          if (i < text.length) {
            this.AIQuestionAnswerData.find(f=>f.Id==id).Content += text.charAt(i);
            i++;
          } else {
            clearInterval(interval);
          }
        }, speed);
      },
      // 左侧菜单显示隐藏
      NavShowHide(){
        if(this.LeftNavShow){
          this.LeftNavShow=false;
          this.LeftNavStyle='ani_hide';
          this.ContentStyle='con_ani_hide';
        }
        else{
          this.LeftNavShow=true;
          this.LeftNavStyle='ani_show';
          this.ContentStyle='con_ani_show';
        }
      },
      // 添加新对话
      AddNewMsgBtn(){
        if(this.IsLogin){
          this.AIQuestionAnswerData=[];
          this.UserMsgNow={};
          this.SendChatId=null;
          this.GetGreetings();//问候语
        }
        else{
          this.$router.push('/login')
        }
      },
      QListClose(){
        this.QListShow=false;
      },
      // 常用问题
      QListBtn(str){
        this.UserMessage = str;
        this.QListShow=false;
        this.SendMsgDialogBox();// 发送消息，获取数据流，显示对话框
      },
      // 发送信息，获取数据流，显示对话框
      SendMsgDialogBox(){
        if(this.IsLogin){
          if(this.IsSendOk){
            if(this.UserMessage.trim()){
              this.DefaultBoxShow=false;//隐藏问候语
              let id0 = 'user'+new Date().getTime();
              this.AIQuestionAnswerData.push({Id:id0,Type:'right',Content:this.UserMessage});
              // 刷新滚动条
              this.$nextTick(()=>{
                document.getElementById("dialogcontent").scrollTop = document.getElementById("dialogcontent").scrollHeight;
              });
              let usermsg = this.UserMessage;
              this.UserMessage='';//清空输入框
              this.IsSendOk=false;//禁用发送
            
              let id1 = 'think'+new Date().getTime();
              this.AIQuestionAnswerData.push({Id:id1,Type:'left',Content:'',Hide:false,TinkTxt:'思考中...',ConShow:false});
              this.WaitLoading(true);//隐藏数据加载
  
              let id2 = 'answer'+new Date().getTime();
              this.AIQuestionAnswerData.push({Id:id2,Type:'left',Content:'',Hide:true});
              
              let that=this;
              this.userctrl = new AbortController();
              let info = getStore('LoginData');
              fetchEventSource((PageConfig.APIHost?PageConfig.APIHost:Config.APIHost)+'/api/Chat/SendChat', {
                openWhenHidden:true,
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'token': (info?JSON.parse(info).Token:''),
                  'orgCode':getStore('OrgCode'),
                  'terminalType':0
                },
                body: JSON.stringify({
                  Id:(that.SendChatId?that.SendChatId:0),
                  Message:usermsg,
                  IsDeepThink:that.IsDeepThink,
                  IsWebSearch:that.IsWebSearch
                }),
                signal: this.userctrl.signal,//用于控制和取消 fetch 请求
                onopen(arr){
                  // 长链接创建成功
                },
                onmessage(msg) {
                  // 返回数据流
                  // 判断错误内容
                  if(msg.data=='error'){
                    return;
                  }
                  // 思考开始，不做任何处理
                  if(msg.data=='think'){
                    return;
                  }
                  // 不做任何处理
                  if(msg.event=='heart'){
                    return;
                  }
                  that.WaitLoading(true);//显示数据加载
                  // 数据流结束
                  if(msg.data=='[DONE]'){
                    that.WaitLoading(false);//隐藏数据加载
                    return;
                  }
                  // 思考输出中，显示思考内容
                  let cs = that.AIQuestionAnswerData.find(f=>f.Id==id1);
                  if(cs){
                    cs.ConShow = true;
                  }
                  // 回答开始，显示回答对话框
                  if(msg.data=='text'){
                    let th = that.AIQuestionAnswerData.find(f=>f.Id==id2);
                    if(th){
                      th.Hide = false;
                    }
                    return;
                  }
                  // 输出思考或回答内容
                  let arr = JSON.parse(msg.data);
                  // 处理错误内容
                  if(arr.Code){
                    // Message({ type: 'error', message: arr.Message});
                    let obj1 = that.AIQuestionAnswerData.find(f=>f.Id==id1);
                    if(obj1){
                      obj1.Hide = true;
                    }
                    let obj2 = that.AIQuestionAnswerData.find(f=>f.Id==id2);
                    if(obj2){
                      obj2.Hide = true;
                    }
                    let obj0 = that.AIQuestionAnswerData.find(f=>f.Id==id0);
                    if(obj0){
                      obj0.Hide = true;
                    }
                    if(arr.Code==112){
                      that.$router.push('/login')
                    }
                    if(arr.Code==113){
                      that.$router.push('/openvip?source=Chat')
                    }
                    if(arr.Code==120){
                      Message({ type: 'info', message: '请完善高考信息！'});
                      that.$router.push('/examinee?source=Chat');
                    }
                    if(arr.Code==121){
                      Message({ type: 'info', message: '请完善高考成绩！'});
                      that.$router.push('/setRealScore?source=Chat');
                    }
                    if(arr.Code==999){
                      Message({ type: 'info', message: arr.Message});
                    }
                    return;
                  }
                  // 思考内容
                  if(arr.type=='think'){
                    let obj = that.AIQuestionAnswerData.find(f=>f.Id==id1);
                    if(obj){
                      obj.Content +=arr.msg;
                      obj.TinkTxt =arr.title;
                    }
                  }
                  // 回答内容
                  if(arr.type=='text'){
                    let obj = that.AIQuestionAnswerData.find(f=>f.Id==id2);
                    if(obj){
                      obj.Content +=arr.msg;
                    }
                  }
                  // 结束
                  if(arr.type=='meta'){
                    that.IsSendOk=true;//开启发送
                    that.SendChatId=arr.chatId;
                    that.GetChatList(arr.chatId);
                  }
                  document.getElementById("dialogcontent").scrollTop = document.getElementById("dialogcontent").scrollHeight;// 刷新滚动条
                },
                onclose() {
                  // 长连接关闭
                  that.IsSendOk=true;//开启发送
                  that.setTableStyle([id2]);// 处理table表格样式
                  that.WaitLoading(false);//隐藏数据加载
                  that.IsVip();
                  document.getElementById("dialogcontent").scrollTop = document.getElementById("dialogcontent").scrollHeight;// 刷新滚动条
                },
                onerror(err) {
                  // 异常或代码报错
                  that.setTableStyle();// 处理table表格样式
                  that.IsSendOk=true;//开启发送
                  that.WaitLoading(false);//隐藏数据加载
                  // return 1000*3600
                  // Message({ type: 'info', message: "出错了，请刷新重试！"});
                  this.userctrl.abort();
                  throw err;
                }
              });
            }
            else{
              Message({ type: 'info', message: '请输入您的问题！'});
            }
          }
          else{
            Message({ type: 'info', message: 'AI正在回答您的问题，请稍后再试！'});
            this.UserMessage='';//清空输入框
          }
        }
        else{
          this.$router.push("/login");
        }
      },
      // 等待加载数据
      WaitLoading(b){
        let wobj = document.getElementById('markdown-wait-animate');
        if(wobj){
          if(b){
            wobj.style.display="block";
          }
          else{
            wobj.style.display="none";
          }
        }
      },
      // 处理table表格样式
      setTableStyle(arr){
        let that = this;
        let lblist = document.getElementsByClassName('jzy-vue-markdown-class-left');
        if(lblist.length>0){
          lblist.forEach(lb => {
            lb.children.forEach(it=>{
              if(it.className=='markdown-table-class'){
                let box = document.createElement('div');
                box.classList.add('jzy-markdown-table-botton');
                lb.insertBefore(box, it);
  
                let btn2 = document.createElement('div');
                btn2.classList.add('btn');
                btn2.classList.add('el-icon-rank');
                btn2.title='放大表格';
                // btn2.addEventListener("click", function() {
                //   that.TableAmplify(btn2);
                // });
                box.appendChild(btn2);
  
                let div = document.createElement('div');
                div.classList.add('jzy-markdown-table-style-default');
                // let CHeight = (document.body.clientHeight || document.documentElement.clientHeight);
                // div.style.maxHeight=(CHeight-300)+'px';
                lb.insertBefore(div, it);
                div.appendChild(it);
              }
            });
          });
        }
        if(arr&&arr.length>0){
          arr.forEach(obj=>{
            let item = document.getElementById(obj);
            let xbtn = document.createElement('div');
            xbtn.classList.add('export_now_content_btn');
            xbtn.classList.add('el-icon-upload2');
            xbtn.innerText=' 导出当前内容';
            xbtn.addEventListener("click", function() {
              that.ContentExport(item);
            });
            item.parentElement.appendChild(xbtn);
          })
        }
        const scrollableList = document.getElementsByClassName('jzy-markdown-table-style-default');
          if(scrollableList.length>0){
              for(let i=0;i<scrollableList.length;i++){
                  let isDragging = false;
                  let startX = 0;
                  let scrollStartLeft = 0;
              
                  scrollableList[i].addEventListener('mousedown', function(event) {
                      if (event.button === 0) { // 确保是左键点击
                          event.preventDefault(); // 防止文本被选中
                          isDragging = true;
                          startX = event.clientX;
                          scrollStartLeft =  scrollableList[i].scrollLeft;
                          document.body.style.cursor = "pointer";
                      }
                  });
              
                  document.addEventListener('mousemove', function(event) {
                      if (isDragging) {
                          event.preventDefault(); // 防止文本被选中
                          const dy = event.clientX - startX; // 计算鼠标移动的水平距离
                          scrollableList[i].scrollLeft = scrollStartLeft - dy; // 更新滚动条位置
                      }
                  });
              
                  document.addEventListener('mouseup', function() {
                      isDragging = false;
                      document.body.style.cursor = "default";
                  });
  
                  let that = this;
                  scrollableList[i].previousElementSibling.children[0].addEventListener('click', function() {
                    that.AmplifyTableShow=true;
                    that.AmplifyTableHtml=scrollableList[i].children[0].outerHTML;
                  });
              }
          }
      },
      //导出整个对话
      AllConetntExport(){
        document.getElementById("result_download_loading").style.display = 'block';
        let arr = document.getElementsByClassName('export_now_content_btn');
        if(arr){
          arr.forEach(it => {
            it.style.opacity='0';
          });
        }
        downloadPDF(document.getElementById('All_Conetnt_Export'),arr);
      },
      //导出表格
      TableExport(){
        document.getElementById("result_download_loading").style.display = 'block';
        downloadPDF(document.getElementById('table_export_pdf_box'));
      },
      //导出内容
      ContentExport(item){
        document.getElementById("result_download_loading").style.display = 'block';
        downloadPDF(item);
      },
      // 放大表格
      TableAmplify(dom){
        this.AmplifyTableShow=true;
        this.AmplifyTableHtml=dom.offsetParent.nextElementSibling.children[0].outerHTML;
      },
      // 显示、隐藏思考内容
      ContentShowOrHide(id){
        let obj = this.AIQuestionAnswerData.find(f=>f.Id==id);
        if(obj.ConShow){
          obj.ConShow=false;
        }
        else{
          obj.ConShow=true;
        }
      },
      // 判断终端
      isPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
        }
        return flag;
      },
      //跳转外部地址
      ToLink(url){
        window.open(url);
      },
    }
  }
  </script>
  <style scoped lang="less">
  textarea,input{background:none;padding:0rem;-webkit-border-radius:0rem;-moz-border-radius:0rem;border-radius:0rem;-webkit-appearance:none;}input[type=password]{-webkit-text-security:disc;}textarea:focus,input:focus,button:focus{outline:none;}
  .page_box{
    width: 100%;
    height: 100%;
    background-color: #fff;
    .left_box.ani_hide{
      animation:ani_hide 0.2s linear 0s 1;
      -webkit-animation:ani_hide 0.2s linear 0s 1;
      animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      @-webkit-keyframes ani_hide {
        from {width: 260px;}
        to {width: 60px;}
      }
      @keyframes ani_hide {
        from {width: 260px;}
        to {width: 60px;}
      }
    }
    .left_box.ani_show{
      animation:ani_show 0.2s linear 0s 1;
      -webkit-animation:ani_show 0.2s linear 0s 1;
      animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      @-webkit-keyframes ani_show {
        from {width: 60px;}
        to {width: 260px;}
      }
      @keyframes ani_show {
        from {width: 60px;}
        to {width: 260px;}
      }
    }
    .left_box{
      width: 260px;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 1;
      overflow: hidden;
      user-select: none;
      background-color: #f7f7f7;
      .border_box{
        width: calc(100% - 1px);
        height: 100%;
        border-right: 1px solid #ddd;
        .top_box{
          width: 100%;
          height: 50px;
          border-bottom: 1px solid #ddd;
          position: relative;
          .sname{
            color: #222;
            font-size: 18px;
            line-height: 50px;
            display: block;
            overflow: hidden;
            height: 100%;
            text-indent: 10px;
          }
          .openico{
            position: absolute;
            right: 0;
            top: 0;
            width: 60px;
            height: 50px;
            font-size: 20px;
            color: #888787;
            cursor: pointer;
            line-height: 50px;
            text-align: center;
            background-color: #f7f7f7;
          }
          .openico.hide{
            transform: rotate(-180deg);
            -webkit-transform: rotate(-180deg);
          }
          .openico:hover{
            color: #686868;
          }
        }
        .addnewmsg{
          width: 100%;
          height: 50px;
          padding-top: 10px;
          .addbtn{
            width: calc(100% - 40px);
            height: 40px;
            background-color: #e9dddd;
            line-height: 40px;
            text-align: center;
            border-radius: 10px;
            margin: auto;
            color: #333;
            font-size: 15px;
            letter-spacing: 1px;
            i{
              width: 50px;
              color: #555;
              font-size: 18px;
              display:inline-block;
            }
          }
          .addbtn:hover{
            cursor: pointer;
            background-color: #e7cccc;
            color: #333;
          }
        }
        .list_box{
          width: 100%;
          height: calc(100% - 172px);
          border-bottom: 1px solid #ddd;
          padding: 0px 0px 10px;
          .scrollbox{
            width: 100%;
            height: 100%;
            .nomsg{
              text-align: center;
              color: #9e9d9d;
              font-size: 13px;
              line-height: 80px;
            }
            .grouptit{
              width: 100%;
              height: 30px;
              text-indent: 20px;
              line-height: 30px;
              color: #555;
              font-size: 14px;
              background-color: #f1f0e3;
              position: relative;
              margin-top: 4px;
              i{
                display: block;
                position: absolute;
                right: 0;
                top: 0;
                width: 30px;
                text-align: center;
                line-height: 30px;
                height: 100%;
                text-indent: 0;
                color: #999;
                font-size: 14px;
              }
            }
            .grouptit:first-child{
              margin-top: 0;
            }
            .grouptit:hover{
              cursor: pointer;
            }
            .msg_box{
              width: 100%;
              .lbox{
                margin: 5px 10px;
                height: 38px;
                position: relative;
                cursor: pointer;
                border-radius: 5px;
                .title{
                  width: calc(100% - 40px);
                  height: 36px;
                  overflow: hidden;
                  color: #444;
                  font-size: 14px;
                  display: inline-block;
                  line-height: 36px;
                  position: absolute;
                  left: 0;
                  text-indent: 10px;
                  z-index: 1;
                }
                i{
                  width: 28px;
                  height: 28px;
                  font-size: 18px;
                  text-align: center;
                  line-height: 28px;
                  color: #999;
                  transform: rotate(90deg);
                  position: absolute;
                  right: 5px;
                  top: 5px;
                  display: none;
                }
                i:hover{
                  background-color: #dcdcdc;
                  border-radius: 5px;
                }
                .edit_box{
                  display: none;
                  width: 100px;
                  position: absolute;
                  right: 0px;
                  top: 40px;
                  z-index: 1;
                  background-color: #fff;
                  border-radius: 5px;
                  overflow: hidden;
                  border: 1px solid #ddd;
                }
              }
              .lbox.on{
                background-color: #e8e8e8;
              }
              .lbox:hover{
                background-color: #e8e8e8;
                .title{
                  color: #333;
                }
                i{
                    display: inline-block;
                }
                .edit_box{
                  display: block;
                }
              }
            }
          }
        }
        .bottom_box{
          width: 100%;
          height: 50px;
          line-height: 50px;
          user-select: none;
          position: relative;
          .user{
            color: #444;
            font-size: 14px;
            display: block;
            width: 100%;
            text-indent: 10px;
            .name{
              position: relative;
              .vip{
                position: absolute;
                right: -22px;
                top: -23px;
                z-index: 1;
                i{
                  color: #f5c164;
                  font-size: 17px;
                }
              }
            }
            .tlogin{
              color: #666;
              cursor: pointer;
              text-decoration: underline;
              font-size: 13px;
            }
            .tlogin:hover{
              color: rgba(232, 76, 51, 1);
            }
          }
        }
      }
    }
    .dialog_box.con_ani_hide{
      animation:con_ani_hide 0.2s linear 0s 1;
      -webkit-animation:con_ani_hide 0.2s linear 0s 1;
      animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      @-webkit-keyframes con_ani_hide {
        from {width: calc(100% - 261px);}
        to {width: calc(100% - 61px);}
      }
      @keyframes con_ani_hide {
        from {width: calc(100% - 261px);}
        to {width: calc(100% - 61px);}
      }
    }
    .dialog_box.con_ani_show{
      animation:con_ani_show 0.2s linear 0s 1;
      -webkit-animation:con_ani_show 0.2s linear 0s 1;
      animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      @-webkit-keyframes con_ani_show {
        from {width: calc(100% - 61px);}
        to {width: calc(100% - 261px);}
      }
      @keyframes con_ani_show {
        from {width: calc(100% - 61px);}
        to {width: calc(100% - 261px);}
      }
    }
    .dialog_box{
      width: calc(100% - 261px);
      background-color: #fff;
      overflow: hidden;
      position: fixed;
      right: 0;
      z-index: 1;
      height:100%;
      top:0px;
      .content_on{
        width: 100%;
        height: 80px;
        user-select: none;
      }
      .dialog_content{
        width: 100%;
        height: calc(100% - 267px);
        overflow-x: hidden;
        overflow-y: auto;
        position: relative;
        .default-box{
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 1;
          .dbox{
            margin-top: 100px;
            text-align: center;
            opacity: 0;
            animation:dshow 1s linear 0s 1;
            -webkit-animation:dshow 1s linear 0s 1;
            animation-fill-mode: forwards;
            -webkit-animation-fill-mode: forwards;
            .lntxt{
              display: inline-block;
              .logo{
                display: block;
                height: 50px;
                float: left;
              }
              .name{
                color: rgba(232, 76, 51, 1);
                font-size: 30px;
                font-weight: bold;
                line-height: 50px;
                float: left;
                margin-left: 20px;
              }
            }
            .greetings{
              color: #666;
              font-size: 14px;
              line-height: 24px;
              margin: 20px auto 0;
              max-width: 800px;
            }
          }
          @-webkit-keyframes dshow {
            from {opacity: 0;}
            to {opacity: 1;}
          }
          @keyframes dshow {
            from {opacity: 0;}
            to {opacity: 1;}
          }
        }
        .content_div{
          margin: 0 100px;
          #markdown-wait-animate{
            display: none;
            height: 40px;
            width: 100%;
            position: relative;
            .ico{
              animation:waiting 1s linear 0s infinite;
              -webkit-animation:waiting 1s linear 0s infinite;
              position: absolute;
              left: 24px;
              top: 5px;
              z-index: 1;
              width: 30px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              color: #999;
              font-size: 20px;
            }
          }
          @-webkit-keyframes waiting {
            0% {transform: rotate(0deg);}
            100% {transform: rotate(360deg);}
          }
          @keyframes waiting {
            0% {transform: rotate(0deg);}
            100% {transform: rotate(360deg);}
          }
        }
        .content_box{
          overflow: hidden;
          .text{
            color: #222;
            font-size: 15px;
            line-height: 34px;
            padding: 8px 10px;
            text-align: justify;
            .thinking{
              color: #888;
              font-size: 14px;
              margin: 0 20px;
            }
            .thinked{
              margin: 0 20px;
              position: relative;
              color: #888;
              font-size: 14px;
              cursor: pointer;
              user-select: none;
              border-bottom: 1px solid #cfcfcf;
              i{
                position: absolute;
                right: 0px;
                top: -4px;
                display: block;
                width: 30px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                color: #a1a1a1;
                font-size: 20px;
                z-index: 1;
                cursor: pointer;
                user-select: none;
              }
              i:hover{
                color: #727272;
              }
              i.up{
                transform: rotate(-180deg);
                -webkit-transform: rotate(-180deg);
              }
            }
          }
        }
        .content_box.left{
          .text{
            width: calc(100% - 20px);
            float: left;
            .think{
              color: #707070;
              font-size: 14px;
              line-height: 26px;
            }
          }
        }
        .content_box.right{
          animation:usermsgshow 0.5s linear 0s 1;
          -webkit-animation:usermsgshow 0.5s linear 0s 1;
          @-webkit-keyframes usermsgshow {
            from {opacity: 0;}
            to {opacity: 1;}
          }
          @keyframes usermsgshow {
            from {opacity: 0;}
            to {opacity: 1;}
          }
          .text{
            margin: 32px 0px;
            max-width: calc(100% - 20px);
            float: right;
            border-top-left-radius: 5px;
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 5px;
            text-align: left;
            background-color: #f3f3f3;
          }
        }
      }
      .item_box{
        width: 100%;
        height: 50px;
        overflow: hidden;
        background-color: #fff;
        user-select: none;
        .itemcon{
          margin-top: 12px;
          width: 100%;
          overflow-x: auto;
          .item{
            display: inline-block;
            padding: 2px 12px;
            border: 1px solid #e9e8e8;
            border-radius: 20px;
            color: #615f5f;
            font-size: 13px;
            background-color: #fff;
            margin: 0 10px;
            i{
              margin-right: 3px;
              color: #a0a0a0;
            }
          }
          .item:hover{
            cursor: pointer;
            background-color: #f3f3f3;
          }
        }
      }
      .dialog_bot{
        height: 155px;
        margin: 0 100px;
        z-index: 200;
        position: relative;
        .input_div{
          margin: 5px 27px 0 10px;
          position: relative;
          .linear{
            background: linear-gradient(0deg,rgba(255,255,255,1),rgba(255,255,255,0));
            position: absolute;
            top: -20px;
            left: 10px;
            width: calc(100% - 20px);
            height: 20px;
            z-index: 10;
          }
        }
      }
      .bottom_div{
        width: 100%;
        text-align: center;
        height: 20px;
        line-height: 20px;
        span{
          color: #999;
          font-size: 12px;
        }
      }
      .dialog_input{
        margin: 0 10px;
        height: 100px;
        background-color: #fff;
        border: 1px solid #ddd;
        border-radius: 10px;
        .input_box{
          position: relative;
          left: 0;
          top: 0;
          width: 100%;
          z-index: 11;
          .textarea{
            display: block;
            height: 55px;
            resize: none;
            border: none;
            background-color: #fff;
            color: #666;
            font-size: 14px;
            line-height: 20px;
            margin: 0 10px;
            margin-top: 5px;
            width: calc(100% - 20px);
            scrollbar-width: none;
            -ms-overflow-style: none;
          }
          .botton{
            height: 40px;
            margin: 0 10px;
            background-color: #fff;
            .more{
              float: left;
              width: 40px;
              height: 40px;
              text-align: center;
              line-height: 40px;
              font-size: 22px;
              color: #999;
            }
            .lbtns{
              float: left;
            }
            .rbtns{
              float: right;
            }
            .btn:hover{
              cursor: pointer;
            }
            .btn.num{
              float: left;
              line-height: 32px;
              margin-right: 20px;
            }
            .btn.send{
              width: 40px;
              height: 40px;
              float: left;
              transform: rotate(90deg);
              -webkit-transform: rotate(90deg);
              i{
                font-size: 30px;
                color: #7e7e7e;
              }
            }
            .btn.sd,.btn.lw{
              padding: 5px 10px;
              background-color: #f3f3f3;
              border-radius: 5px;
              color: #666;
              font-size: 14px;
              float: left;
              margin: 5px 10px 0 0;
              border: 1px solid #eee;
              i{
                margin-right: 5px;
              }
            }
            .btn.sd.on,.btn.lw.on{
              color: #555;
              border: 1px solid #f0eaea;
              background-color: #f0eaea;
            }
          }
        }
      }
    }
    .qlist_box{
      width: 100%;
      height: 100%;
      user-select: none;
      overflow: hidden;
      .scrollbox{
        width: 100%;
        height: 100%;
        .qtitle{
          margin: 0 20px;
          padding: 12px 0;
          color: #555;
          font-size: 16px;
          line-height: 22px;
          font-weight: bold;
          margin-top: 20px;
        }
        .qtxt{
          margin: 10px 20px;
          padding: 8px 40px 8px 10px;
          color: #333;
          font-size: 14px;
          line-height: 22px;
          border: 1px solid #e4e4e4;
          border-radius: 5px;
          position: relative;
          i{
            font-size: 14px;
            color: #666;
            position: absolute;
            right: 10px;
            top: 11px;
            z-index: 1;
          }
        }
        .qtxt:hover{
          cursor: pointer;
          background-color: #e8e8e8;
        }
      }
    }
  }
  .fz_box_div{
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 110;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.6);
    .fzbox{
      max-width: 800px;
      background-color: #fff;
      margin: 100px auto 0;
      border-radius: 5px;
      overflow: hidden;
      text-align: center;
      .tit{
        color: #555;
        font-size: 24px;
        margin-top: 50px;
      }
      .link{
        color: #0076bf;
        font-size: 20px;
        margin: 50px 0;
        display: inline-block;
      }
      .mark{
        color: #555;
        font-size: 16px;
      }
      .close{
        display: inline-block;
        padding: 10px 30px;
        color: #666;
        font-size: 16px;
        border: 1px solid #ddd;
        border-radius: 5px;
        margin-top: 80px;
        letter-spacing: 2px;
        margin-bottom: 50px;
        cursor: pointer;
      }
    }
  }
  </style>
  <style>
  .left_box .border_box .list_box .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .page_box .left_box .border_box .list_box .lbox .el-dropdown{
    width: 100%;
    height: 40px;
    line-height: 40px;
  }
  .el-popconfirm .el-popconfirm__main{
    margin: 10px 0 20px 0;
  }
  .el-popconfirm .el-popconfirm__action .el-button--text{
    border-color:#e2e2e2;
    padding: 7px 15px;
  }
  .page_box .dialog_box .content_on .el-dropdown{
    height: 100%;
  }
  .page_box .dialog_box .content_on .el-dropdown-link{
    display: inline-block;
    font-size: 16px;
    color: #666;
    text-indent: 50px;
    width: 100%;
    line-height: 80px;
    cursor: pointer;
  }
  .page_box .dialog_box .content_on .el-dropdown-link:hover{
    color: #444;
  }
  .page_box .left_box .border_box .bottom_box .el-dropdown{
    width: 60px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    background-color: #f7f7f7;
  }
  .page_box .left_box .border_box .bottom_box .el-dropdown-link{
    width: 30px;
    height: 100%;
    display: inline-block;
  }
  .el-message-box{
    width: auto !important;
    min-width: 360px !important;
  }
  </style>
  <style lang="less">
  .jzy-vue-markdown-class-left{
    padding: 20px 20px 0;
  }
  .jzy-vue-markdown-class-left table {
    border: 1px solid #ddd;
    border-collapse: collapse;
    min-width: 100%;
    width: max-content;
    width: -moz-max-content;
    width: -webkit-max-content;
    max-width: max-content;
    max-width: -webkit-max-content;
    max-width: -moz-max-content;
    border-radius: 5px !important;
  }
  .jzy-vue-markdown-class-left table thead{
    background: #fff;
  }
  .jzy-vue-markdown-class-left table thead th{
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background-color: #eceaea;
    padding: 0px 10px;
    max-width: 300px;
    vertical-align: middle;
    white-space:normal;
    box-sizing: border-box;
  }
  .jzy-vue-markdown-class-left table thead th:last-child{
    border-right:none;
  }
  .jzy-vue-markdown-class-left table tbody td{
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    padding: 0px 10px;
    max-width: 300px;
    vertical-align: middle;
    white-space:normal;
    box-sizing: border-box;
  }
  .jzy-vue-markdown-class-left table tbody td:last-child{
    border-right:none;
  }
  .jzy-vue-markdown-class-left table tbody tr:last-child td{
    border-bottom:none;
  }
  .export_now_content_btn{
    color: #555;
    font-size: 14px;
    background-color: rgba(232, 76, 51, 0.2);
    margin: 10px 0px 20px 20px;
    display: inline-block;
    padding: 9px 15px;
    border-radius: 5px;
    line-height: normal;
  }
  .export_now_content_btn:hover{
    cursor: pointer;
    background-color: rgba(232, 76, 51, 0.3);
  }
  .export_all_content_btn{
    display: inline-block;
    background-color: rgba(232, 76, 51, 0.2);
    padding: 8px 10px;
    border-radius: 5px;
    color: #555;
    font-size: 14px;
    margin-left: 20px;
    margin-top: 22px;
    cursor: pointer;
  }
  .export_all_content_btn:hover{
    background-color: rgba(232, 76, 51, 0.3);
  }
  .jzy-markdown-table-style-default{
    overflow-y: auto;
    overflow-x: auto;
    border: 1px solid #ddd;
    // width: max-content;
    // width: -moz-max-content;
    // width: -webkit-max-content;
    // max-width: 100%;
  }
  .jzy-markdown-table-botton{
    display: inline-block;
    height: 32px;
    background-color: #eceaea;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    cursor: pointer;
    border: 1px solid #dfdddd;
    line-height: normal;
    border-bottom: 0px;
    position: relative;
    z-index: 1;
    padding: 0 5px;
    .btn{
      height: 24px;
      line-height: 24px;
      padding: 0 8px;
      border-radius: 5px;
      color: #5e5d5d;
      font-size: 16px;
      margin: 3px 0px 0 0;
      display: inline-block;
    }
    .btn:hover{
      background-color: #fff;
    }
  }
  .jzy-markdown-table-style-default table{
    border:none;
  }
  .el-scrollbar__wrap{
    overflow-x: hidden;
  }
  .qlist_box .el-drawer__header{
    margin-bottom: 0;
  }
  .amplifytablebox{
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(0,0,0,0.5);
    left: 0;
    top: 0;
    z-index: 200;
    .conbox{
      width: calc(100% - 20px);
      height: calc(100% - 20px);
      background-color: #fff;
      position: relative;
      top: 10px;
      left: 10px;
      border-radius: 5px;
      .tablescroll{
        width: 100% ;
        height: calc(100% - 50px);
        border-bottom: 1px solid #ddd;
      }
      .tablebox{
        line-height: 24px;
        padding: 20px;
        table{
          border: 1px solid #ddd;
          border-collapse: collapse;
          min-width: 100%;
          width: max-content;
          width: -moz-max-content;
          width: -webkit-max-content;
          max-width: max-content;
          max-width: -webkit-max-content;
          max-width: -moz-max-content;
          border-radius: 5px !important;
          thead{
            background: #fff; /* 背景色，确保头部清晰可见 */
            th{
              border-right: 1px solid #ddd;
              border-bottom: 1px solid #ddd;
              background-color: #eceaea;
              padding: 5px 10px;
              max-width: 300px;
              vertical-align: middle;
              white-space:normal;
              box-sizing: border-box;
              text-align: left;
            }
          }
          thead th:last-child{
            border-right:none;
          }
          tbody{
            tr:last-child td{
              border-bottom:none;
            }
            tr{
              td{
                border-right: 1px solid #ddd;
                border-bottom: 1px solid #ddd;
                padding: 5px 10px;
                max-width: 300px;
                vertical-align: middle;
                white-space:normal;
                box-sizing: border-box;
              }
              td:last-child{
                border-right:none;
              }
            }
          }
        } 
      }
      .btnbox{
        width: 100%;
        height: 50px;
        text-align: center;
        .exportbtn{
          width: 100px;
          height: 34px;
          margin: 8px 10px;
          color: #fff;
          font-size: 14px;
          background-color: #12757c;
          text-align: center;
          line-height: 34px;
          border-radius: 5px;
          display: inline-block;
        }
        .exportbtn:hover{
          opacity: 0.8;
          cursor: pointer;
        }
        .closebtn{
          width: 100px;
          height: 34px;
          margin: 8px 10px;
          color: #666;
          font-size: 14px;
          background-color: #e1e2e2;
          text-align: center;
          line-height: 34px;
          border-radius: 5px;
          display: inline-block;
        }
        .closebtn:hover{
          cursor: pointer;
          background-color: #d9d9da;
        }
      }
      
    }
  }
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    color: rgba(232, 76, 51, 1);
  }
  </style>